// This import loads the firebase namespace along with all its type information.
import Team from './team-model'

export async function load_teams(): Promise<Team[]> {
  throw 'Not implemented'
}

export async function delete_team(): Promise<boolean> {
  throw 'Not implemented'
}

export async function store_team(): Promise<Team> {
  throw 'Not implemented'
}
